export default "__VITE_ASSET__ODbXrrj4__"